import { Component } from '@angular/core';

@Component({
  selector: 'rnpl-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {

}
